import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const TrimsShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Trims Section"
    sectionKey="Trims"
    backRoute="/sections/trims"
  />
);

export default TrimsShipmentRequest;
